import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useEffect, useState } from 'react'
import { useWindowSize } from 'usehooks-ts'
import './main.css'

import { VermoegensChart } from 'components/VermoegensChart'
import { EinkommensChart } from 'components/EinkommensChart'

import Header from 'components/Header'
import { MFContextProvider } from 'components/MFHelpers'
import de from 'components/Locale/de'
import fr from 'components/Locale/fr'
import Form from 'components/Form'

const debug = window.document.title === 'TA-Interaktiv Microfrontend'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  var part = properties?.part || 0

  const [height, setHeight] = useState(0)
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712

  useEffect(() => {
    setHeight(window.innerHeight)
  }, [])

  useEffect(() => {
    setHeight(window.innerHeight)
  }, [windowSize.width])

  return (
    <AppContainer $colorMode={colorMode}>
      <MFContextProvider
        locale={tenant.lang}
        colorMode={colorMode}
        translations={{ de, fr }}
        tenantKey={tenant.key}
        properties={properties || {}}
        trackEvent={trackEvent}
      >
        <StylesWrapper
          height={
            isMobile ? height * 1.1 : Math.min(windowSize.width * 0.75, height)
          }
        >
          {(part === 'header' || debug) && (
            <Header tenant={tenant} colorMode={colorMode} />
          )}
          {(part === '0' || debug) && <Form />}
          {(part === '1' || debug) && <EinkommensChart />}
          {(part === '2' || debug) && <VermoegensChart />}
        </StylesWrapper>
      </MFContextProvider>
    </AppContainer>
  )
}

const StylesWrapper = styled.div<{ height: number }>`
  .Scroller {
    margin-bottom: 30px;
  }
  .back {
    /* height:${(props) => props.height * 0.5}px; */
    /* overflow: visible; */
  }
  .front {
    /* pointer-events: none; */
    margin-top: ${({ height }) => -height}px;
  }
`

const AppContainer = styled(TamediaStyles)`
  ${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
